module.exports = __webpack_public_path__ + "static/media/1.6f8ec4a6.png";